import styled from 'styled-components'

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 190%;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 180%;
  }
`

export const Annotation = styled.p`
  font-size: 16px;
  line-height: 130%;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 160%;
  }
`
